// Header.js
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import IconBackground from "./IconBackground";
import HeaderState from "./HeaderState";
import HeaderMenu from "./HeaderMenu";
import HeaderTabs from "./HeaderTabs";
import { useAuth } from "../context/AuthProvider";
import MorphingTextHeader from "./MorphingTextHeader"; // Import the header-specific component

// Auth Action Handler Component
function AuthActionHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");
    const oobCode = queryParams.get("oobCode");
    
    if (!mode || !oobCode) return;
    
    console.log("Auth action detected:", mode, "with code:", oobCode);
    
    // Redirect based on action type
    if (mode === "resetPassword") {
      console.log("Redirecting to password reset page");
      navigate(`/reset-password?oobCode=${oobCode}`);
    } else if (mode === "verifyEmail") {
      console.log("Redirecting to email verification page");
      navigate(`/verify-email?oobCode=${oobCode}`);
    }
  }, [location, navigate]);
  
  // This component doesn't render anything
  return null;
}

const Header = () => {
  const {
    activeTab,
    setActiveTab,
    menuOpen,
    setMenuOpen,
    showTabs,
    setShowTabs,
    selectedTier,
    setSelectedTier,
    formData,
    setFormData,
    errors,
    setErrors,
    isLoading,
    setIsLoading,
    handleSubmit,
  } = HeaderState();

  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Redirect logged-in users to dashboard
  useEffect(() => {
    if (currentUser) {
      navigate("/dashboard");
    }
  }, [currentUser, navigate]);

  // Define a function to open the menu
  const openMenu = () => setMenuOpen(true);

  // If user is logged in, don't render the header content
  // (they'll be redirected to dashboard)
  if (currentUser) {
    return <AuthActionHandler />; // Still include the action handler for redirects
  }

  return (
    <>
      {/* Add Auth Action Handler to intercept and redirect auth actions */}
      <AuthActionHandler />
      
      {/* Add the Icon Background Behind Everything */}
      <IconBackground />

      <header className={styles.headerContainer}>
        {/* Banner */}
        <div className={styles.banner}>
          {/* Use the header-specific morphing text component */}
          <MorphingTextHeader />
        </div>

        {/* Header Content */}
        <div className={styles.headerContent}>
          {/* Menu Toggle Button */}
          <button
            className={styles.menuIcon}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>

        {/* Navigation Menu */}
        <HeaderMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        {/* Header Tabs for login/signup */}
        <HeaderTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          showTabs={showTabs}
          setShowTabs={setShowTabs}
          selectedTier={selectedTier}
          setSelectedTier={setSelectedTier}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          handleSubmit={handleSubmit}
          openMenu={openMenu}
        />

        {/* Extra space div to ensure content doesn't get cut off */}
        <div className={styles.extraBottomSpace}></div>
      </header>
    </>
  );
};

export default Header;